import React, { useEffect, useState } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import apiClient from '../api/client';

export default function MvpOzonPanel({ clientId }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    apiClient.get('/mvp/ozon', { params: { client_id: clientId } })
      .then(({ data: d }) => { if (!cancelled) setData(d); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [clientId]);

  if (loading) return <p className="text-[var(--wb-text-muted)]">Загрузка Ozon…</p>;

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-bold">Ozon — реклама и воронка</h2>

      <div className="grid md:grid-cols-3 gap-3">
        {(data?.campaigns || []).map((c) => (
          <div key={c.campaign_id} className="wb-card p-4">
            <p className="font-medium truncate">{c.title}</p>
            <p className="text-xs text-[var(--wb-text-muted)] mt-1">{c.payment_type} · {c.state}</p>
            <p className="text-sm mt-2">Бюджет/день: {Number(c.daily_budget || 0).toLocaleString('ru-RU')} ₽</p>
          </div>
        ))}
      </div>

      <div className="wb-card p-4">
        <h3 className="text-sm font-semibold mb-3">Реклама по дням</h3>
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data?.daily || []}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="stat_date" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 11 }} />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="spend" name="Расход" stroke="#ef4444" dot={false} />
              <Line type="monotone" dataKey="revenue" name="Выручка" stroke="#10b981" dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
